import { useEffect, useRef } from "react"
import { AppState } from "react-native"

// Calls `callback(msAway)` when the app comes back from the background — on
// the web, when the tab becomes visible again (react-native-web maps AppState
// to the page visibility). An "inactive" blip (iOS control center, a system
// prompt) is not a return: only a real "background" arms the next "active".
export function useOnAppForeground(callback) {
    const callbackRef = useRef(callback)
    callbackRef.current = callback

    useEffect(() => {
        // Mounted while already in the background (a VoIP launch, a hidden
        // tab): the first return counts.
        let backgroundSince =
            AppState.currentState === "background" ? Date.now() : null
        const subscription = AppState.addEventListener("change", (state) => {
            if (state === "background") {
                if (backgroundSince === null) backgroundSince = Date.now()
            } else if (state === "active" && backgroundSince !== null) {
                const msAway = Date.now() - backgroundSince
                backgroundSince = null
                callbackRef.current(msAway)
            }
        })
        return () => subscription?.remove()
    }, [])
}
